import { Text, Skeleton } from '@genial/components';
import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';

import { cohortCellGapHorizontal, cohortCellHeight } from '../../constants';

export namespace CohortHeaderTypes {
  export type Props = {
    columns: number;
    isLoading?: boolean;
  };
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    gap: cohortCellGapHorizontal,
    justifyContent: 'center',
    height: cohortCellHeight,
    minHeight: cohortCellHeight,
  },
  cell: {
    flex: 1,
    height: cohortCellHeight,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export const CohortHeader: React.FC<CohortHeaderTypes.Props> = ({ columns, isLoading }) => {
  const cells = useMemo(
    () =>
      Array(columns)
        .fill(undefined)
        .map((_, index) => (
          <View key={index.toString()} style={styles.cell}>
            {isLoading ? (
              <Skeleton width="100%" borderRadius="sm" height="inline.xxxs" />
            ) : (
              <Text>{index}</Text>
            )}
          </View>
        )),
    [columns, isLoading]
  );

  return (
    <View style={styles.container}>
      <Text flex={1} alignItems="center" display="flex">
        {isLoading ? <Skeleton width="100%" borderRadius="sm" height="inline.xxxs" /> : 'Mês/Ano'}
      </Text>
      {cells}
      <Text flex={1} alignItems="center" display="flex">
        {isLoading ? <Skeleton width="100%" borderRadius="sm" height="inline.xxxs" /> : 'To'}
      </Text>
    </View>
  );
};
